let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("hBIh6")]).then(() => parcelRequire('gnLzh'));